import React from 'react'

import Header from "../componets/Header";
import Footer from "../componets/Footer";
import Callback from "../componets/contact/Callback";
import Map from '../componets/contact/Map';

const Contact = () => {
    return (
        <>
            <div className="bs-contact-page">
                <Header/>
                <Callback />
                <Map/>
                <Footer/>
            </div>
        </>
    )
}

export default Contact